import IParser from "@/types/IParser"
import ParseError from "@/types/ParseError"
import { BillEmail } from "./billEmail"
import { IBillEmail } from "./billEmail.types"
import { BillEmail as BillEmailDto } from "@/api/backofficeRest/generated/model"

export type IBillEmailRaw = BillEmailDto

export const BillEmailParser: IParser<IBillEmail, IBillEmailRaw> = {
  toDomain: (data: IBillEmailRaw) => {
    try {
      return new BillEmail(Number(data.id), data.deliveryStatus)
    } catch (error) {
      throw new ParseError(error)
    }
  },
}
